import React from 'react';
import { useNavigate } from 'react-router-dom';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // If fallback is a React element, render it directly
      if (React.isValidElement(this.props.fallback)) {
        return this.props.fallback;
      }
      // If fallback is a component, render it
      if (typeof this.props.fallback === 'function') {
        const FallbackComponent = this.props.fallback;
        return <FallbackComponent />;
      }
      // Default fallback
      return <div>Da ist etwas schiefgelaufen.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
